<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >
    <block-hero :target-info="targetInfo" :color-scheme="colorScheme"/>
    <block-about-slider :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <block-three-years :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <block-about-counselor :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <!-- <block-fortune-cat
      :lp-id="lpId"
      :color-scheme="colorScheme"
    /> -->
    <block-menus
      v-if="menusList && menusList.length"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :menu-list="menusList"
      :lp-id="lpId"
    />
    <!--
    <block-banner
      v-if="showBanner"
      :lp-id="lpId"
      banner-pos="bottom"
      :color-scheme="colorScheme"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :campaign="bannerType" :target-info="targetInfo" />
      -->
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockHero from './blocks/BlockHero'
import BlockAboutCounselor from './blocks/BlockAboutCounselor'
import BlockFortuneCat from './blocks/BlockFortuneCat'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockAboutSlider from '@/utvStore/components/Products/somarimone/partials/BlockAboutSlider'
import BlockThreeYears from '@/utvStore/components/Products/somarimone/partials/BlockThreeYears'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockHero,
    BlockAboutCounselor,
    BlockBanner,
    BlockMenus,
    BlockFortuneCat,
    BlockAboutSlider,
    BlockThreeYears,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    campaignMessage: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
  },
  computed:{
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}

.lp-child-base {
  color: #32373F;
  &--invalidCpno {}
  .block-banner {
    padding: 40px 0;
  }



  .block-menu-base {
    background: #FEFAF0;
    padding: 60px 0 60px;
    /deep/ {
      .block-menu-base__swiper {
        margin-top: 75px;
      }
      .swiper-slide {
        padding-top: 24px;
      }
      .block-menu-base__category {
        position: static;
        margin: 0 auto 20px;
      }

    }
  }
  /deep/ {
    .basic-block {
      z-index: unset;
      .content-wrap {
        z-index: 0;
      }
    }
    .block-about-counselor-base__inner{
      padding: 20px 20px 0;
      @include mq(w580){
        padding: 70px 20px 0;
      }
    }
    .baseButton__button {
      min-width: 242px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/LpMain.vue